import CTPLFormPage from "../../components/organisms/CTPL/index";

const FormPage = (props) =>{
    return <CTPLFormPage sendGTM={props.sendGTM}/>
};
export default FormPage;